// Torricelli orifice flow Q = Cd · A · √(2·g·h) for an exposed leak
export const CD = { free: 0.62, soil: 0.45 };
const G = 9.81;
const n = (v) => (v === '' || v == null || !Number.isFinite(+v) ? 0 : +v);

export function leakArea(c = {}) {
  if (c.geo === 'photo') return n(c.photoArea);
  if (c.geo === 'crack') return n(c.l) * n(c.w);
  if (c.geo === 'ring') return Math.PI * n(c.dn) * n(c.gap);
  return Math.PI * (n(c.d) / 2) ** 2;
}

export function leakFlow(c = {}) {
  const A = leakArea(c) / 1e6, h = n(c.bar) * 10.197, cd = CD[c.cd || 'soil'];
  const ls = A > 0 && h > 0 ? cd * A * Math.sqrt(2 * G * h) * 1000 : 0;
  const m3a = ls * 3.6 * 24 * 365;
  const tgt = c.target ? (c.tUnit === 'm3h' ? n(c.target) / 3.6 : n(c.target)) : 0;
  const ratio = tgt > 0 ? ls / tgt : null;
  const verdict = ratio == null ? null : ratio >= 0.8 && ratio <= 1.2 ? 'ok' : ratio > 1.2 ? 'over' : ratio >= 0.75 ? 'warn' : 'miss';
  return { area: leakArea(c), ls, lmin: ls * 60, m3h: ls * 3.6, m3d: ls * 86.4, m3a, eur: m3a * n(c.price ?? 2.5), tgt, ratio, rest: Math.max(0, tgt - ls), verdict, ...leakRange(A, h, cd) };
}

// uncertainty band: outflow coefficient 0.45–0.62 (soil … free jet), leak area ±20 %, pressure ±10 %
function leakRange(A, h, cd) {
  if (!(A > 0 && h > 0)) return { lo: 0, hi: 0 };
  const q = (k, a, p) => k * A * a * Math.sqrt(2 * G * h * p) * 1000;
  return { lo: q(Math.min(cd, CD.soil), 0.8, 0.9), hi: q(Math.max(cd, CD.free), 1.2, 1.1) };
}

export const f1 = (v, d = 1) => v.toLocaleString(undefined, { minimumFractionDigits: d, maximumFractionDigits: d });

// verified savings from meter / night-minimum flow before and after repair
export function flowSaved(fc = {}, price = localStorage.getItem('giss_water_price') || 2.5) {
  const k = fc.unit === 'm3h' ? 1 / 3.6 : 1, b = n(fc.before) * k, a = n(fc.after) * k;
  if (!(b > 0) || fc.after === '' || fc.after == null) return null;
  const ls = b - a, m3a = ls * 3.6 * 24 * 365;
  return { b, a, ls, pct: (ls / b) * 100, m3d: ls * 86.4, m3a, eur: m3a * n(price) };
}
